import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { Link, withPrefix } from 'gatsby';
// import path from 'path';
import TableWithFilters from './table-with-filters';

const HTMLParser = ({
  html: rawHtml,
  lang,
  // pages, fileDirectory, prefix
}) => {
  const html = rawHtml.split('<p>[GREY-SECTION]</p>')[0];
  // Transformer for React HTML Parser
  const transform = (node, index) => {
    // Eksterne links
    if (
      node.type === 'tag' &&
      node.name === 'a' &&
      node.attribs.href &&
      ((node.attribs.href || '').startsWith('http://') ||
        (node.attribs.href || '').startsWith('https://'))
    ) {
      return (
        <a
          href={node.attribs.href}
          key={index}
          {...node.attribs}
          target="_blank"
          rel="noreferrer noopener"
        >
          {node.children.map((n, i) => convertNodeToElement(n, i, transform))}
        </a>
      );
    }

    // File download links — render as plain <a> so the browser handles the
    // download attribute instead of Gatsby's router treating it as a route.
    if (
      node.type === 'tag' &&
      node.name === 'a' &&
      node.attribs.href &&
      node.attribs.download !== undefined
    ) {
      if (node.attribs.class) {
        node.attribs.className = node.attribs.class;
        delete node.attribs.class;
      }

      // Strip the language prefix (matching the <Link> path) and re-add the
      // current Gatsby pathPrefix via withPrefix — empty in dev, "/en-us" etc.
      // in prod — so the href works the same in both environments.
      let bare = node.attribs.href;
      if (bare.startsWith('/en-us/')) bare = bare.replace('/en-us/', '/');
      else if (bare.startsWith('/da-dk/')) bare = bare.replace('/da-dk/', '/');
      else if (bare.startsWith('/de-de/')) bare = bare.replace('/de-de/', '/');

      const { href: _, ...rest } = node.attribs;
      return (
        <a href={withPrefix(bare)} key={index} {...rest}>
          {node.children.map((n, i) => convertNodeToElement(n, i, transform))}
        </a>
      );
    }

    // Interne Links
    if (
      node.type === 'tag' &&
      node.name === 'a' &&
      node.attribs.href &&
      (node.attribs['aria-label'] || '').indexOf('permalink') === -1 &&
      (node.attribs.href || '').indexOf('http://') === -1 &&
      (node.attribs.href || '').indexOf('https://') === -1 &&
      (node.attribs.href || '').indexOf('mailto:') === -1 &&
      (node.attribs.href || '').indexOf('tel:') === -1 &&
      (node.attribs.href || '').indexOf('#') !== 0 &&
      !node.attribs.href.startsWith('/images/')
    ) {
      if (node.attribs && node.attribs.class) {
        node.attribs.className = node.attribs.class;
        delete node.attribs.class;
      }
      // console.log('@ intern link', node.attribs.href);

      let to = node.attribs.href.split('#')[0];
      to = (to || '').trim();
      // console.log('/to', to);
      const hash = node.attribs.href.split('#')[1];
      delete node.attribs.href;

      if (to.endsWith('.md')) {
        // throw new Error('Link til .md fil =>', to);
      }
      // if (to.substr(to.length - 3).toLowerCase() === '.md') {
      //   const toFilePath = decodeURIComponent(to)
      //     .trim()
      //     .replace(`/${prefix}/`, '/');

      //   const relativePagePath = path.normalize(
      //     `${fileDirectory}/${toFilePath}`
      //   );

      //   const page = pages.find(
      //     (p) =>
      //       p.filePath.toLowerCase() === toFilePath.toLowerCase() ||
      //       p.filePath.toLowerCase() === relativePagePath.toLowerCase()
      //   );

      //   if (page) {
      //     console.log('@@ html - page found', page);

      //     to = page.path;
      //     if (node.children.length === 0) {
      //       node.children.push({
      //         data: page.title,
      //         next: null,
      //         parent: node,
      //         prev: null,
      //         type: 'text',
      //       });
      //     }
      //   } else {
      //     console.log('//Error: Page for MD link not found:', {
      //       to,
      //       relativePagePath,
      //       fileDirectory,
      //       prefix,
      //       toFilePath,
      //       toDecoded: decodeURIComponent(to),
      //       pages,
      //     });
      //     return null;
      //   }
      // }

      if (to.startsWith('/en-us/en-us/')) {
        to = to.replace('/en-us/en-us/', '/en-us/');
      }
      if (to.startsWith('/da-dk/da-dk/')) {
        to = to.replace('/da-dk/da-dk/', '/da-dk/');
      }
      if (to.startsWith('/de-de/de-de/')) {
        to = to.replace('/de-de/de-de/', '/de-de/');
      }
      if (to.startsWith('/en-us/')) {
        to = to.replace('/en-us/', '/');
      }
      if (to.startsWith('/da-dk/')) {
        to = to.replace('/da-dk/', '/');
      }
      if (to.startsWith('/de-de/')) {
        to = to.replace('/de-de/', '/');
      }

      return (
        <Link
          to={`${to}${hash ? `#${hash} ` : ''}`}
          key={index}
          {...node.attribs}
        >
          {node.children.map((n, i) => convertNodeToElement(n, i, transform))}
        </Link>
      );
    }

    // Helper function to get locale from lang
    const getLocale = (language) => {
      if (!language) return 'en-US';
      const langLower = language.toLowerCase();
      if (langLower === 'da' || langLower === 'da-dk') return 'da-DK';
      if (langLower === 'de' || langLower === 'de-de') return 'de-DE';
      if (langLower === 'en' || langLower === 'en-us') return 'en-US';
      if (langLower.length === 2) {
        return `${langLower}-${langLower.toUpperCase()}`;
      }
      return language;
    };

    // Helper function to sort a table node
    const sortTableNode = (tableNode, shouldSort, columnIndex = 1) => {
      if (!shouldSort || !lang) return tableNode;

      const locale = getLocale(lang);
      // Convert to 0-based index (1 = first column = index 0)
      const sortColumnIndex = Math.max(0, columnIndex - 1);

      // Clone the node to avoid mutation
      const processedNode = { ...tableNode, children: [...tableNode.children] };

      // Find tbody and sort its rows
      const tbodyIndex = processedNode.children.findIndex(
        (child) => child.type === 'tag' && child.name === 'tbody'
      );

      if (tbodyIndex !== -1) {
        const tbody = processedNode.children[tbodyIndex];
        const rows = tbody.children.filter(
          (child) => child.type === 'tag' && child.name === 'tr'
        );

        // Sort rows based on specified column
        const sortedRows = [...rows].sort((a, b) => {
          const getCellText = (row, colIndex) => {
            const cells = row.children.filter(
              (child) =>
                child.type === 'tag' &&
                (child.name === 'td' || child.name === 'th')
            );
            if (cells.length === 0 || colIndex >= cells.length) return '';

            const targetCell = cells[colIndex];
            let text = '';

            const extractText = (node) => {
              if (node.type === 'text') {
                text += node.data;
              } else if (node.children) {
                node.children.forEach(extractText);
              }
            };

            extractText(targetCell);
            return text.trim();
          };

          const textA = getCellText(a, sortColumnIndex);
          const textB = getCellText(b, sortColumnIndex);

          return textA.localeCompare(textB, locale, { sensitivity: 'base' });
        });

        // Replace tbody with sorted version
        processedNode.children[tbodyIndex] = {
          ...tbody,
          children: sortedRows,
        };
      }

      return processedNode;
    };

    // Check for table-with-filters first (before regular tables)
    if (node.attribs?.class?.includes('table-with-filters')) {
      const shouldSort = node.attribs['data-alphabetical-sort'] !== undefined;
      const columnIndex = node.attribs['data-alphabetical-sort']
        ? parseInt(node.attribs['data-alphabetical-sort'], 10) || 1
        : 1;

      // If we need to sort, find the table inside and sort it
      let processedNode = node;
      if (shouldSort) {
        processedNode = { ...node, children: [...node.children] };
        const tableIndex = processedNode.children.findIndex(
          (child) => child.type === 'tag' && child.name === 'table'
        );

        if (tableIndex !== -1) {
          const tableNode = processedNode.children[tableIndex];
          processedNode.children[tableIndex] = sortTableNode(
            tableNode,
            true,
            columnIndex
          );
        }
      }

      return (
        <TableWithFilters
          node={processedNode}
          transform={transform}
          index={index}
        />
      );
    }

    // Check for div wrapper with data-alphabetical-sort (but not table-with-filters)
    if (
      node.type === 'tag' &&
      node.name === 'div' &&
      node.attribs['data-alphabetical-sort'] !== undefined
    ) {
      const columnIndex = node.attribs['data-alphabetical-sort']
        ? parseInt(node.attribs['data-alphabetical-sort'], 10) || 1
        : 1;

      // Find the table inside and sort it
      let processedNode = { ...node, children: [...node.children] };
      const tableIndex = processedNode.children.findIndex(
        (child) => child.type === 'tag' && child.name === 'table'
      );

      if (tableIndex !== -1) {
        const tableNode = processedNode.children[tableIndex];
        processedNode.children[tableIndex] = sortTableNode(
          tableNode,
          true,
          columnIndex
        );
      }

      // Return the div wrapper with the sorted table inside
      return (
        <div key={index} {...node.attribs}>
          {processedNode.children.map((n, i) =>
            convertNodeToElement(n, i, transform)
          )}
        </div>
      );
    }

    // Regular tables
    if (node.type === 'tag' && node.name === 'table') {
      const shouldSort = node.attribs['data-alphabetical-sort'] !== undefined;
      const columnIndex = node.attribs['data-alphabetical-sort']
        ? parseInt(node.attribs['data-alphabetical-sort'], 10) || 1
        : 1;
      const processedNode = sortTableNode(node, shouldSort, columnIndex);

      return (
        <div key={index} className="tbl table-scroll-wrapper">
          <table className="table" {...node.attribs}>
            {processedNode.children.map((n, i) => {
              const elem = convertNodeToElement(n, i, transform);
              // Remove weird whitespace linebreaks inside table (illegal)
              if (typeof elem === 'string' && elem.trim() === '') {
                return null;
              }
              return elem;
            })}
          </table>
        </div>
      );
    }

    // Svg bugs
    if (node.type === 'tag' && node.name === 'svg') {
      const { width, height, viewbox, preserveaspectratio, ...others } =
        node.attribs;
      return (
        <svg
          key={index}
          width={width}
          height={height}
          viewBox={viewbox}
          preserveAspectRatio={preserveaspectratio}
          {...others}
        >
          {node.children.map((n, i) => {
            if (
              n.attribs['fill-rule'] &&
              n.type === 'tag' &&
              n.name === 'path'
            ) {
              const { 'fill-rule': fillRule, ...otherAttr } = n.attribs;

              return <path key={i} fillRule={fillRule} {...otherAttr} />;
            }
            return convertNodeToElement(n, i, transform);
          })}
        </svg>
      );
    }

    // Images
    // if (node.type === 'tag' && node.name === 'img') {
    //   // node.attribs.src = node.attribs.src;
    //   return <img key={index} {...node.attribs} />;
    // }
  };

  return ReactHtmlParser(html, {
    transform,
    decodeEntities: true,
  });
};

HTMLParser.propTypes = {
  html: PropTypes.string.isRequired,
  lang: PropTypes.string,
  // pages: PropTypes.array.isRequired,
};
HTMLParser.defaultProps = {};

export default HTMLParser;
